import React from 'react';
import { AppBar, Box, Button, Toolbar } from '@mui/material';
import { ChevronLeft, Close as CloseIcon } from '@mui/icons-material';

export const BackNavIconVariant = {
  Chevron: 'chevron',
  Close: 'close',
} as const;

export type BackNavIconVariant = (typeof BackNavIconVariant)[keyof typeof BackNavIconVariant];

export interface NavigationHeaderProps {
  backUrl?: string;
  backNavIcon?: BackNavIconVariant;
  backNavAriaLabel?: string;
  onBackClick?: () => void;
  leftItems?: React.ReactNode;
  rightItems?: React.ReactNode;
  global?: boolean;
}

export const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  backUrl,
  backNavIcon,
  backNavAriaLabel,
  onBackClick,
  leftItems,
  rightItems,
  global = false,
}) => {
  const backAriaLabel = backNavAriaLabel ?? 'Back';

  const handleBack = async () => {
    if (onBackClick) {
      await onBackClick();
    }
  };

  const isCloseBackNav = backNavIcon === BackNavIconVariant.Close;

  return (
    <AppBar
      color='primary'
      position='static'
      className={`lex-navigation-header ${global ? 'lex-navigation-header--global' : ''}`}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2,
      }}
    >
      <Toolbar
        sx={{
          flexGrow: 1,
          px: 4,
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', flexGrow: 1, minWidth: 0, alignItems: 'center', gap: 2 }}>
          {isCloseBackNav ? (
            <Button
              component='button'
              type='button'
              onClick={handleBack}
              size='small'
              className='icon-only'
              aria-label={backAriaLabel}
            >
              <CloseIcon sx={{ fontSize: 22 }} />
            </Button>
          ) : (backUrl || onBackClick) ? (
            <Button
              {...(backUrl ? { href: backUrl } : { component: 'button', type: 'button' as const })}
              onClick={handleBack}
              size='small'
              className='icon-only'
              aria-label={backAriaLabel}
            >
              <ChevronLeft />
            </Button>
          ) : null}
          {leftItems}
        </Box>
        {rightItems && <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>{rightItems}</Box>}
      </Toolbar>
    </AppBar>
  );
};

export default NavigationHeader;
